import { type UseQueryResult, useQuery } from 'react-query';
import { AwardAgreementDocumentImportService } from '../../services/wealthlane-award-services/services/AwardAgreementDocumentImportService';
import {
  HoldingPdfService,
  Wealthlane_AwardService_Dtos_AwardDocumentDto_AwardDocumentDto,
} from '../../services/wealthlane-award-services';

const useGetHoldingPDF = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_AwardDocumentDto_AwardDocumentDto[] | undefined,
  unknown
> => {
  const holdingPDF = useQuery(['getHoldingPDF'], async () => {
    return await handleRequest(HoldingPdfService.getApiAwardApiHoldingMyHoldingPdf());
  });

  return holdingPDF;
};

export default useGetHoldingPDF;
